import React from 'react';

//Mui
import { Box } from '@mui/material';

const Footer = () => {
  return (
    <footer>
      <Box textTransform="capitalize" p={3}>
        all right reserved.
      </Box>
    </footer>
  );
};

export default Footer;
